import type {
    SupplierInsightsService,
    InsightsOverview,
    InsightsSupplier,
    InsightsTransaction,
    InsightsPurchaseOrder,
    InsightsPoLine,
} from '../types';

/**
 * Supplier Insights (internal reporting) service.
 *
 * Backend endpoints aren't built yet, so this returns zeroed/empty data. The
 * Insights screens are fully wired to these methods and will populate once the
 * real implementation lands here.
 */
export const awsSupplierInsightsService: SupplierInsightsService = {
    async getOverview(): Promise<InsightsOverview> {
        return { supplierCount: 0, asnCount: 0, onTimePct: 0, errorRate: 0 };
    },

    async listSuppliers(): Promise<InsightsSupplier[]> {
        return [];
    },

    async listTransactions(): Promise<InsightsTransaction[]> {
        return [];
    },

    async listPurchaseOrders(): Promise<InsightsPurchaseOrder[]> {
        return [];
    },

    async listPoLines(): Promise<InsightsPoLine[]> {
        return [];
    },
};

export default awsSupplierInsightsService;
